import { Collection, DeviceAccessor } from "@mcleod/core";
import { Layout } from "..";
import { IdProps } from "./ComponentProps";

interface RegisteredComponentType {
    constructor: any;
    isCompound?: boolean;
    constructorProps?: string[];
}

const registeredAppTypes: Collection<RegisteredComponentType> = {};
const registeredTypes: Collection<RegisteredComponentType> = {};

export class ComponentTypes {
    public static registerComponentType(type: string, props: RegisteredComponentType) {
        registeredTypes[type] = props;
    }

    public static registerAppComponentType(type: string, props: RegisteredComponentType) {
        registeredAppTypes[type] = props;
    }

    private static getComponentType(type: string): RegisteredComponentType {
        if (DeviceAccessor.isApp) {
            return registeredAppTypes[type] ?? registeredTypes[type];
        }
        return registeredTypes[type];
    }

    public static isCompoundComponentType(type: string): boolean {
        return ComponentTypes.getComponentType(type)?.isCompound ?? false
    }

    public static getComponentTypeConstructorProps(type: string): string[] {
        return ComponentTypes.getComponentType(type)?.constructorProps;
    }

    public static createComponentOfType(type: string, props: IdProps): any {
        if (type === "layout")
            return Layout.getLayout(props?.["layoutName"], props);
        const c = ComponentTypes.getComponentType(type)?.constructor;
        if (c == null)
            throw new Error("Could not find a constructor for " + type + " / " + (props == null ? "no id" : props.id));
        return new c(props);
    }
}
